import { AddonName } from "../../../configs/constants";

const getLocalizedField = (obj, field, isRtl) => {
  if (!obj) return "";
  const primary = isRtl ? `${field}_ar` : field;
  const fallback = isRtl ? field : `${field}_ar`;
  return obj[primary] || obj[fallback] || "";
};

export const getAddonName = (addon, isRtl = false) =>
  getLocalizedField(addon, "name", isRtl);

export const getAddonDescription = (addon, isRtl = false) =>
  getLocalizedField(addon, "description", isRtl);

export const getAddonImage = (addon) =>
  addon?.image || "/images/image-not-found.png";

export const getAddonPriceValue = (addon) => {
  const price = Number(addon?.price) || 0;
  const discount = Number(addon?.discount) || 0;
  return Math.max(price - discount, 0);
};

export const isAddonFree = (addon) => getAddonPriceValue(addon) <= 0;

const mapNames = (list, isRtl) =>
  (list || []).map((item) => getAddonName(item, isRtl)).filter(Boolean);

export const getAddonDependencyNames = (addon, isRtl = false) =>
  mapNames(addon?.dependent_addons, isRtl);

export const getAddonRequiredByNames = (addon, isRtl = false) =>
  mapNames(addon?.required_by_addons, isRtl);

const CONFLICT_RULES = [
  {
    name: AddonName.TableManagement,
    conflicts: [AddonName.JobManagement],
    reasonKey: "cannot_select_table_management_while_job_management_is_active",
  },
  {
    name: AddonName.JobManagement,
    conflicts: [AddonName.WaiterManagement, AddonName.TableManagement],
    reasonKey:
      "cannot_select_job_management_while_waiter_management_or_table_management_is_active",
  },
  {
    name: AddonName.WaiterManagement,
    conflicts: [AddonName.JobManagement],
    reasonKey: "cannot_select_waiter_management_while_job_management_is_active",
  },
];

export const getAddonBlockedReasonKey = (addon, activeAddons = []) => {
  if (!addon || addon.is_subscribed) return "";

  const rule = CONFLICT_RULES.find((r) => r.name === addon?.name);
  if (!rule) return "";

  const activeNames = new Set(
    activeAddons.filter((a) => a?.id).map((a) => a?.name),
  );

  return rule.conflicts.some((c) => activeNames.has(c)) ? rule.reasonKey : "";
};

export const extractError = (err, fallback = "") =>
  err?.response?.data?.message ||
  err?.response?.data?.error ||
  err?.message ||
  fallback;
